<template>
  <div class="landing">
    <header-main></header-main>
    <landing-card></landing-card>
    <landing-steps></landing-steps>
    <landing-packets></landing-packets>
    <landing-line></landing-line>
    <landing-list-icons></landing-list-icons>
    <landing-faq></landing-faq>
    <landing-line></landing-line>
    <landing-numbers></landing-numbers>
    <!-- <landing-opinions></landing-opinions> -->
    <landing-last></landing-last>
    <footer-main></footer-main>
    <nav-mobile></nav-mobile>
  </div>
</template>

<script>
import HeaderMain from '@/components/HeaderMain.vue'
import LandingCard from '@/components/LandingCard.vue'
import LandingSteps from '@/components/LandingSteps.vue'
import LandingPackets from '@/components/LandingPackets.vue'
import LandingFaq from '@/components/LandingFaq.vue'
import LandingListIcons from '@/components/LandingListIcons.vue'
import LandingNumbers from '@/components/LandingNumbers.vue'
import LandingOpinions from '@/components/LandingOpinions.vue'
import LandingLast from '@/components/LandingLast.vue'
import FooterMain from '@/components/FooterMain.vue'
import NavMobile from '@/components/NavMobile.vue'
import LandingLine from '@/components/LandingLine.vue'

export default {
  name: 'Landing',
  components: {
    HeaderMain,
    LandingCard,
    LandingSteps,
    LandingPackets,
    LandingFaq,
    LandingListIcons,
    LandingNumbers,
    LandingOpinions,
    LandingLast,
    FooterMain,
    NavMobile,
    LandingLine,
  }
}
</script>
<style lang="scss">
  div.landing { height: 100%; }
</style>
